// API helpers for Stage 2 (pairs) and Stage 4 (jigsaw); authenticated with the `sessionId&organizationId` token

async function request(path, token, body) {
  const isForm = body instanceof FormData;
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/${path}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      ...(isForm ? {} : { "Content-Type": "application/json" }),
    },
    body: isForm ? body : JSON.stringify(body || {}),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.success === false) throw new Error(json.message || json.error || "Request failed");
  return json;
}

export const getAdminPairs = ({ token, themeName }) => request("getAdminPairs", token, { themeName });
export const deletePair = ({ token, id }) => request("deletePair", token, { id });
/** formData: themeName, type (text|image), item1, item2, image */
export const savePair = ({ token, formData }) => request("savePair", token, formData);
/** formData: themeName, pairs (JSON), image_<id> */
export const updatePairs = ({ token, formData }) => request("updatePairs", token, formData);

/** formData: themeName, file */
export const uploadPuzzleImage = ({ token, formData }) => request("uploadPuzzleImage", token, formData);
export const savePuzzleGrid = ({ token, themeName, rows, cols, imgCount }) =>
  request("savePuzzleGrid", token, { themeName, rows, cols, img_count: imgCount });

/** Reads the pixel size of an image file in the browser. */
export function imageSize(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve({ width: img.width, height: img.height });
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Could not read the image"));
    };
    img.src = url;
  });
}

/** formData: themeName, stage (1-4), file (PNG) — or reset=true */
export const uploadChallengeImage = ({ token, formData }) => request("uploadChallengeImage", token, formData);
